import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import TankEditForm from '~/containers/tankEdit/tankEdit';
import TankArchive from '~/containers/tankArchive/tankArchive';

export class TankEditPage extends Component {
  state = {
    tank: null
  };

  onReceiveTank = ({ tank }) => {
    this.setState({
      tank
    });
  };

  render() {
    const tankId = this.props.match.params.tankId;
    const { tank } = this.state;

    const editButton = (
      <div className="flex">
        <TankArchive className="mr4" tank={tank} />
        <Link to={`/tanks/${tankId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar back="/tanks" backText="Tanks" title={tank ? tank.name : '...'} button={editButton} />
        <TankEditForm onCompleted={this.onReceiveTank} id={tankId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(TankEditPage));



// WEBPACK FOOTER //
// ./src/pages/tankEdit/tankEdit.jsx